// import { vuex as modules } from '../app/vuex'
// // create a new object and preserv original keys
// export default { ...modules }
import app  from '../app/all-stores'
// create a new object and preserv original keys
export default { ...app.modules }
